import { useState } from "react"
import { useLocation } from "wouter"

const images = [
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771745414-PAO4EW5HDYGQCL6EJ84O/00.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554379713598-GGU03L8915CB9Z05RUM2/suggested_poi.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771793736-O91MFLRQ1NAIM88E9LXA/add_stop.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771804014-7JEDM2OZYYXBNNTWGM1G/000.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1587016229069-KMIHPRT8T5F3TW0WU5G4/NEO_GPMC_s.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554380364438-4ATF86GL8QDTC7RULUJ7/protot.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586777278172-SI2T3HV2O4836KGMYQ28/Apple_Watch_template.jpg?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554744145584-E8WZA243FD0LLPVBI3JX/fab.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1575816417270-4ZX04EZG5F7KVYEUW2P3/1_yrsIiQcGocRs6btQdgqLMQ.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771015188-ELZ41VQ0L61GPH08VRN2/1.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771021595-S0Y0M08R2K0E2QFQYCFG/2.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554384458722-2SAOMFGY3X5TQ8WZAKY5/all.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554379798074-EY69YNY8G2E5IN8JZ3LS/work_shot_1600_1200.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1554392315543-MUZU6HMPISD079LN5ZXU/allllllllll33_final.gif?format=1500w",
  "https://images.squarespace-cdn.com/content/v1/5c84ac92049079044d565a57/1586771820574-UAZATBC60EFCB3FOX9G3/0000.gif?format=1500w",
]

export default function OtherWorks() {
  const [lightbox, setLightbox] = useState(null)
  const [, navigate] = useLocation()

  return (
    <div className="page-panel">
      <div className="panel-inner">

        <div className="panel-header">
          <div className="panel-tag">
            <button className="back-btn" onClick={() => navigate("/work")}>← Work</button>
          </div>
          <h2 className="panel-title">Other<br />Works</h2>
          <p className="panel-subtitle">
            A collection of interaction design, prototyping explorations, and product
            design work across different companies and contexts.
          </p>
        </div>

        <div className="other-works-grid">
          {images.map((src, i) => (
            <div
              key={i}
              className="other-works-item"
              onClick={() => setLightbox(i)}
            >
              <img src={src} alt={`Work ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>

      </div>

      {lightbox !== null && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
          <button
            className="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + images.length) % images.length) }}
          >‹</button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={images[lightbox]} alt={`Work ${lightbox + 1}`} />
          </div>
          <button
            className="lightbox-next"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % images.length) }}
          >›</button>
          <div className="lightbox-counter">{lightbox + 1} / {images.length}</div>
        </div>
      )}
    </div>
  )
}
